export default __webpack_public_path__ + "static/media/plus-black.21bf7be0.svg";